export default __webpack_public_path__ + "static/media/Hallticket3.cbdf9d9f.jpg";